import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ContentGenerationRecord } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Generate/types';
interface ContentGenReviewState {
  contentGenItemsToReview: ContentGenerationRecord[];
  currentContentGenItemIndex: number;
  reviewPage: 'project' | 'generation' | null;
  setContentGenItemsToReview: (items: ContentGenerationRecord[]) => void;
  setCurrentContentGenItemIndex: (index: number) => void;
  setReviewPage: (page: 'project' | 'generation' | null) => void;
  goToNextContentGenItem: () => void;
  goToPreviousContentGenItem: () => void;
  getCurrentContentGenItem: () => ContentGenerationRecord | null;
  getCurrentContentGenId: () => string | null;
  getCurrentContentGenItemIndex: () => number;
  updateCurrentContentGenItem: (item: ContentGenerationRecord) => void;
  hasContentGenItems: () => boolean;
  clearContentGenItems: () => void;
}

export const useContentGenReviewStore = create<ContentGenReviewState>()(
  persist(
    (set, get) => ({
      contentGenItemsToReview: [],
      currentContentGenItemIndex: 0,
      reviewPage: null,

      setContentGenItemsToReview: (items: ContentGenerationRecord[]) =>
        set({
          contentGenItemsToReview: items,
          currentContentGenItemIndex: 0
        }),

      setReviewPage: (page: 'project' | 'generation' | null) => set({ reviewPage: page }),

      getCurrentContentGenItem: () => {
        const state = get();
        return state.contentGenItemsToReview[state.currentContentGenItemIndex] || null;
      },

      getCurrentContentGenId: () => {
        const state = get();
        const currentItem = state.contentGenItemsToReview[state.currentContentGenItemIndex];
        return currentItem?.skuContentGenerationId || null;
      },

      setCurrentContentGenItemIndex: (index: number) => set({ currentContentGenItemIndex: index }),

      hasContentGenItems: () => {
        const state = get();
        return state.contentGenItemsToReview.length > 0;
      },

      goToNextContentGenItem: () =>
        set((state) => ({
          currentContentGenItemIndex: Math.min(
            state.currentContentGenItemIndex + 1,
            state.contentGenItemsToReview.length - 1
          )
        })),

      goToPreviousContentGenItem: () =>
        set((state) => ({
          currentContentGenItemIndex: Math.max(state.currentContentGenItemIndex - 1, 0)
        })),

      getCurrentContentGenItemIndex: () => {
        const state = get();
        return state.currentContentGenItemIndex;
      },

      clearContentGenItems: () =>
        set({
          contentGenItemsToReview: [],
          currentContentGenItemIndex: 0,
          reviewPage: null
        }),

      updateCurrentContentGenItem: (newItem: ContentGenerationRecord) => {
        const state = get();
        set({
          contentGenItemsToReview: state.contentGenItemsToReview.map((item, index) =>
            index === state.currentContentGenItemIndex ? newItem : item
          )
        });
      }
    }),
    {
      name: 'contentGenReviewStore',
      // Persist navigation state and items to review
      partialize: (state) => ({
        contentGenItemsToReview: state.contentGenItemsToReview,
        currentContentGenItemIndex: state.currentContentGenItemIndex,
        reviewPage: state.reviewPage
      })
    }
  )
);
